"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _dividerModule = _interopRequireDefault(require("./divider.module.css"));

const divider = _ref => {
  let {
    alt,
    className,
    containerClassName,
    isReversed,
    isTall,
    isDark,
    isSlant,
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(_dividerModule.default.divider, isReversed && _dividerModule.default.reversed, className)
  }, /*#__PURE__*/_react.default.createElement("span", {
    role: "presentation",
    className: (0, _clsx.default)(_dividerModule.default.background, isTall && _dividerModule.default.tall, isReversed && _dividerModule.default.reversed, isDark && _dividerModule.default.dark, isSlant && _dividerModule.default.slant),
    alt: alt
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(_dividerModule.default.svgContainer, containerClassName)
  }, children));
};

divider.defaultProps = {
  isTall: false,
  isReversed: false,
  isDark: false,
  isSlant: false,
  className: '',
  containerClassName: '',
  alt: 'Content Divider'
};
divider.propTypes = {
  isTall: _propTypes.default.bool,
  isReversed: _propTypes.default.bool,
  isDark: _propTypes.default.bool,
  isSlant: _propTypes.default.bool,
  className: _propTypes.default.string,
  containerClassName: _propTypes.default.string,
  alt: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]) // eslint-disable-line

};
var _default = divider;
exports.default = _default;